import {
  ContentWrapper,
  Image,
  ImageWrapper,
  Name,
  RatingWrapper,
  Wrapper,
} from './content.styles';

import Rating from '../../../../../../../common/rating';
import MiniNutritionFacts from '../../../../../products/product/mini_nutrition_facts';

import useI18nText from '../../../../../../../../hooks/useI18nText';

import type {
  Product,
  ProductProduct,
  ProductWithDynamicPropertiesForUser,
} from '@rewardopl/types';

function getIsProductProduct(product: Product): product is ProductProduct {
  return product.type === 'product';
}

type ContentProps = {
  product: ProductWithDynamicPropertiesForUser;
};

export default function Content({ product }: ContentProps) {
  const { name, name_i18n: nameI18n } = product;

  const nameString = useI18nText(nameI18n, name);

  const isProductProduct = getIsProductProduct(product);

  return (
    <Wrapper>
      {product.picture ? (
        <ImageWrapper>
          <Image
            alt={nameString}
            src={`/api/uploads/${product.picture}?w=${150 * devicePixelRatio}`}
          />
        </ImageWrapper>
      ) : null}
      <ContentWrapper>
        <Name>{nameString}</Name>
        <RatingWrapper>
          <Rating rating={product.rating} />
        </RatingWrapper>
        {isProductProduct ? <MiniNutritionFacts item={product} vertical /> : null}
      </ContentWrapper>
    </Wrapper>
  );
}
